import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Permission } from '../models/permission.model';
import { AppConstants } from '../constant/app.constants';

@Injectable()
export class PermissionService {

    constructor(private http: HttpClient) {
    }
    getAllPermissions() {
        return this.http.get<any>(AppConstants.SITE_URL +'permission/get_All_Permissions');
    }
    getPermissions(permission: Permission) {
        return this.http.post<any>(AppConstants.SITE_URL +'permission/get_permissions', permission);
    }
    getPermissionById(id) {
        return this.http.post<any>(AppConstants.SITE_URL +'permission/get_permission', { id: id });
    }
    savePermission(permission) {
        return this.http.post<any>(AppConstants.SITE_URL +'permission/save_permission', permission);
    }
}




// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/services/permission.service.ts